<template>
  <router-link
    class="button"
    :class="{ inverted: inverted, disabled: disabled }"
    :to="to"
    :inert="disabled ? '' : null"
  >
    <slot />
    <div class="pill-button">
      <YearIcon
        v-if="year"
        :year="year"
        class="pill-button__icon"
      />
      <span class="pill-button__label">{{ label }}</span>
    </div>
  </router-link>
</template>

<script>
import YearIcon from '@/components/common/icons/YearIcon.vue';

export default {
  name: 'PillButton',
  components: {
    YearIcon,
  },
  props: {
    to: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    year: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    inverted: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="stylus" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  --textColor: var(--text-color);
  --bgColor: var(--main-color);

  &.inverted {
    --textColor: var(--inverted-text-color);
    --bgColor: var(--white-color);
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .notice {
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
    color: var(--textColor);
    transition: color 200ms ease-in-out;
  }

  .pill-button {
    display: flex
    align-items: center
    gap: 10px
    padding: 14px 20px
    border-radius: 999px
    border: 1px solid currentColor;
    color: var(--textColor);
    background-color: var(--bgColor);
    transition: background 200ms ease-in-out, color 200ms ease-in-out;
    cursor: pointer
    transition: all 0.2s ease
    pointer-events: auto;

    .button:hover&, .router-link-exact-active& {
      background-color: var(--textColor);
      color: var(--bgColor);
      transition: background 200ms ease-in-out, color 200ms ease-in-out;
    }

    &__icon {
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      line-height: 0.72
      font-size: 10px
      width: 10px;
    }

    &__label{
      font-size: 16px
      font-weight: bold;
    }
  }
}
</style>
